// import {ToastProgrammatic as Toast} from "buefy/types/components";

export function getCookie(name) {
    let cookies = Object.fromEntries(document.cookie.split('; ').map(x => x.split('=')))
    return cookies[name];
};


export function range(start, end) {
    var ans = [];
    for (let i = start; i <= end; i++) {
        ans.push(i);
    }
    return ans;
}

export function formatMoney(value) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function parseResponseErrors(resp) {
    let errorMsg = [];
    for (let errorKey in resp) {
        let error = resp[errorKey];
        errorMsg.push(error);
    }
    return errorMsg.join("\n");
}

function checkBrowser(){
    let browser = "";
    let c = navigator.userAgent.search("Chrome");
    let f = navigator.userAgent.search("Firefox");
    let m8 = navigator.userAgent.search("MSIE 8.0");
    let m9 = navigator.userAgent.search("MSIE 9.0");
    if (c > -1) {
        browser = "Chrome";
    } else if (f > -1) {
        browser = "Firefox";
    } else if (m9 > -1) {
        browser ="MSIE 9.0";
    } else if (m8 > -1) {
        browser ="MSIE 8.0";
    }
    return browser;
}

export function isFirefox(){
    return checkBrowser() === "Firefox";
}

export function isConnexDoor(){
    return getCookie('via') === "sagrika";
}

export function setCookie(name,value,opts) {
    let expires = "";
    if (opts.days) {
        let date = new Date();
        date.setTime(date.getTime() + (opts.days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/; domain="+opts.domain;
}
// export function successMsg(txt) {
//     Toast.open({
//         message: txt,
//         type: 'is-success'
//     });
// }
//
//
// export function dangerMsg(txt) {
//     Toast.open({
//         message: txt,
//         type: 'is-danger'
//     });
// }

export function getRequestHeaders() {
    let csrf = getCookie('csrftoken');

    return {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrf
    };
}

export function setRedirectToAfterUpgrade(location) {
    window.localStorage.setItem('redirectToAfterUpgrade', JSON.stringify(location));
}


export function getRedirectToAfterUpgrade() {
    let route = window.localStorage.getItem('redirectToAfterUpgrade');
    if( route ){
        return JSON.parse(route);
    }
    return false;
}

export function removeRedirectToAfterUpgrade() {
    window.localStorage.removeItem('redirectToAfterUpgrade');
}
